import { Mutation } from 'react-apollo';
import React from 'react';
import Propagator from '../../Propagator';
import gql from 'graphql-tag';

const TOGGLE_SHOW_SUBMISSION_POPUP = gql`
	mutation {
		toggleShowSubmissionPopup @client
	}
`;

export default ({ children }) => (
	<Mutation mutation={TOGGLE_SHOW_SUBMISSION_POPUP}>
		{toggleShowSubmissionPopup =>
			Propagator(children, toggleShowSubmissionPopup)
		}
	</Mutation>
);
